import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const ADD_AUDIO_NOTE = "ADD_AUDIO_NOTE";
export const ADD_AUDIO_NOTE_LOADING =
"ADD_AUDIO_NOTE_LOADING";
export const ADD_AUDIO_NOTE_LOADING_FAILED =
"ADD_AUDIO_NOTE_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const addAudioNOteLoading = ms => ({
    type: ADD_AUDIO_NOTE_LOADING,
    payload: ms
    });
    
    export const addAudioNOteLoadingFailed = ms => ({
    type: ADD_AUDIO_NOTE_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function addAudioNOte(obj) {
    const  request = axios.post(
            `https://prod-legalemirates.wowets.com/fileService/receptionistRoutes/api/v1/cases/uploadAnAudioNote`,obj, {
                headers: { 'Authorization': 'bearer ' +localStorage.receptionistToken}
              });
        
 
    
    return dispatch => {

    dispatch(addAudioNOteLoading());
    request
    .then(response => {   
  
    if (response.status == 200 || response.status == 201) {
     console.log(response,"response addAudioNOte")
    dispatch({
    type: ADD_AUDIO_NOTE,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        addAudioNOteLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(addAudioNOteLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(addAudioNOteLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(addAudioNOteLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


